import gql from 'graphql-tag'

export const CREATE_CATEGORY = gql`
mutation createCategory($eventId: ID!, $category: CreateCategoryInput!) {
  createCategory(eventId: $eventId, category: $category) {
    id
    name,
    color
    zones
  }
}`

export const DELETE_CATEGORY = gql`
mutation deleteCategory($eventId: ID!, $id: ID!) {
  deleteCategory(eventId: $eventId, id: $id) {
    id
  }
}`

export const UPDATE_CATEGORY = gql`
mutation updateCategory($eventId: ID!, $id: ID!, $category: CreateCategoryInput!) {
  updateCategory(eventId: $eventId, id: $id, category: $category) {
    id
  }
}`
